function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M103.178 109.055l6.426 3.71v6.582l-6.426-3.71v-6.582zM157.761 82.525c0 4.302-2.615 9.296-5.839 11.159-3.226 1.86-5.841-.115-5.841-4.417 0-4.298 2.615-9.294 5.841-11.157 3.224-1.862 5.839.115 5.839 4.415z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M152.525 96.454l-4.228-2.38 7.545-16.21 4.045 2.264-7.362 16.326z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M162.151 84.972c0 4.298-2.615 9.294-5.84 11.157-3.225 1.862-5.84-.115-5.84-4.415 0-4.302 2.615-9.296 5.84-11.159 3.225-1.86 5.84.115 5.84 4.417z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M160.097 86.293c0 2.788-1.695 6.027-3.786 7.234-2.092 1.207-3.786-.074-3.786-2.862 0-2.788 1.694-6.026 3.786-7.234 2.091-1.207 3.786.075 3.786 2.862z",
  clipRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M159.028 86.91c0 2.001-1.216 4.326-2.717 5.191-1.5.868-2.717-.052-2.717-2.053s1.217-4.324 2.717-5.191c1.501-.866 2.717.055 2.717 2.053z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M157.624 87.72c0 .97-.588 2.093-1.313 2.511-.727.418-1.314-.026-1.314-.993 0-.966.587-2.09 1.314-2.51.725-.418 1.313.027 1.313.993zM156.563 85.624c0 .185-.115.401-.252.48-.14.08-.251-.004-.251-.19 0-.185.111-.4.251-.48.137-.08.252.004.252.19zM158.265 85.624c0 .185-.112.401-.252.48-.137.08-.252-.004-.252-.19 0-.185.115-.4.252-.48.14-.08.252.004.252.19zM154.997 87.51c0 .184-.111.398-.252.479-.138.08-.251-.005-.251-.19 0-.186.113-.4.251-.48.141-.081.252.004.252.19zM158.265 89.16c0 .185-.112.4-.252.481-.137.08-.252-.004-.252-.189 0-.186.115-.402.252-.483.14-.079.252.006.252.191zM154.997 91.045c0 .185-.111.4-.252.481-.138.08-.251-.006-.251-.19 0-.187.113-.401.251-.482.141-.08.252.005.252.19zM158.673 87.254c0 .187-.113.401-.252.482-.14.08-.252-.005-.252-.191 0-.185.112-.4.252-.481.139-.08.252.006.252.19zM154.494 89.66c0 .187-.112.403-.252.482-.139.08-.252-.004-.252-.19s.113-.4.252-.48c.14-.082.252.004.252.189zM156.563 91.045c0 .185-.115.4-.252.481-.14.08-.251-.006-.251-.19 0-.187.111-.401.251-.482.137-.08.252.005.252.19zM144.055 90.553c0 4.3-2.615 9.295-5.841 11.157-3.225 1.863-5.839-.114-5.839-4.414s2.614-9.297 5.839-11.158c3.226-1.862 5.841.114 5.841 4.415z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M138.817 104.479l-4.228-2.378 7.545-16.209 4.047 2.26-7.364 16.327z",
  clipRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M148.443 92.997c0 4.3-2.614 9.297-5.84 11.158-3.225 1.863-5.839-.114-5.839-4.414s2.614-9.297 5.839-11.16c3.226-1.862 5.84.117 5.84 4.416z",
  clipRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M146.39 94.321c0 2.788-1.696 6.026-3.787 7.234-2.091 1.207-3.786-.074-3.786-2.862 0-2.788 1.695-6.027 3.786-7.234 2.091-1.207 3.787.075 3.787 2.862z",
  clipRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M145.32 94.938c0 2.001-1.218 4.324-2.717 5.191-1.5.866-2.717-.055-2.717-2.053 0-2 1.217-4.325 2.717-5.19 1.499-.868 2.717.051 2.717 2.052z",
  clipRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M143.916 95.749c0 .967-.587 2.089-1.313 2.509-.725.419-1.312-.027-1.312-.992 0-.969.587-2.092 1.312-2.511.726-.417 1.313.027 1.313.994zM142.854 93.65c0 .187-.112.402-.251.482-.138.08-.251-.006-.251-.19 0-.185.113-.4.251-.482.139-.08.251.006.251.19zM144.558 93.65c0 .187-.113.402-.252.482-.14.08-.251-.006-.251-.19 0-.185.111-.4.251-.482.139-.08.252.006.252.19zM141.291 95.536c0 .186-.115.4-.252.481-.14.079-.252-.006-.252-.19 0-.185.112-.401.252-.482.137-.08.252.005.252.19zM144.558 97.187c0 .186-.113.4-.252.481-.14.08-.251-.005-.251-.19s.111-.4.251-.48c.139-.081.252.004.252.189zM141.291 99.072c0 .186-.115.4-.252.48-.14.081-.252-.004-.252-.19 0-.185.112-.4.252-.48.137-.082.252.005.252.19zM144.964 95.282c0 .185-.112.4-.251.48-.138.082-.252-.004-.252-.189 0-.186.114-.402.252-.481.139-.08.251.004.251.19zM140.787 97.689c0 .185-.113.4-.252.481-.14.08-.252-.006-.252-.19 0-.187.112-.401.252-.482.139-.08.252.006.252.19zM142.854 99.072c0 .186-.112.4-.251.48-.138.081-.251-.004-.251-.19 0-.185.113-.4.251-.48.139-.082.251.005.251.19zM97.92 106.937l25.826-15.31 11.685 6.747-25.827 15.308-11.684-6.745z",
  clipRule: "evenodd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M109.604 113.642v5.704l25.827-15.265v-5.708l-25.827 15.269z",
  clipRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M109.604 117.691v.646l24.754-14.511v-.65l-24.754 14.515zM109.604 116.278v.648l24.754-14.511v-.65l-24.754 14.513z",
  clipRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M104.215 113.337c0 4.3-2.615 9.296-5.84 11.157-3.225 1.862-5.84-.113-5.84-4.415 0-4.3 2.615-9.295 5.84-11.157 3.225-1.863 5.84.115 5.84 4.415z",
  clipRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M98.978 127.264l-4.229-2.378 7.547-16.21 4.045 2.262-7.363 16.326z",
  clipRule: "evenodd"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M108.603 115.78c0 4.302-2.615 9.298-5.839 11.161-3.226 1.861-5.84-.115-5.84-4.415 0-4.302 2.614-9.296 5.84-11.159 3.224-1.862 5.839.115 5.839 4.413z",
  clipRule: "evenodd"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M106.55 117.105c0 2.788-1.694 6.027-3.786 7.234-2.091 1.207-3.786-.075-3.786-2.862 0-2.788 1.695-6.026 3.786-7.234 2.092-1.207 3.786.074 3.786 2.862z",
  clipRule: "evenodd"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M105.48 117.722c0 2.001-1.216 4.324-2.716 5.191-1.501.866-2.717-.054-2.717-2.053 0-2.001 1.216-4.326 2.717-5.191 1.5-.866 2.716.053 2.716 2.053z",
  clipRule: "evenodd"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M104.076 118.532c0 .967-.587 2.091-1.312 2.51-.726.418-1.314-.026-1.314-.993s.588-2.092 1.314-2.509c.725-.419 1.312.025 1.312.992zM103.016 116.436c0 .185-.114.399-.252.48-.14.08-.252-.005-.252-.191 0-.185.112-.399.252-.48.138-.082.252.005.252.191zM104.719 116.436c0 .185-.112.399-.252.48-.139.08-.252-.005-.252-.191 0-.185.113-.399.252-.48.14-.082.252.005.252.191zM101.45 118.321c0 .185-.112.399-.252.48-.137.079-.252-.005-.252-.191 0-.185.115-.401.252-.48.14-.08.252.005.252.191zM104.719 119.972c0 .185-.112.399-.252.48-.139.082-.252-.005-.252-.19 0-.186.113-.4.252-.481.14-.08.252.005.252.191zM101.45 121.857c0 .184-.112.399-.252.479-.137.082-.252-.004-.252-.189 0-.186.115-.402.252-.481.14-.081.252.004.252.191zM105.125 118.066c0 .186-.113.401-.251.481-.14.081-.252-.006-.252-.19 0-.185.112-.403.252-.482.138-.08.251.006.251.191zM100.946 120.472c0 .187-.112.401-.25.482-.139.08-.252-.005-.252-.191 0-.185.113-.399.252-.481.138-.081.25.006.25.19zM103.016 121.857c0 .184-.114.399-.252.479-.14.082-.252-.004-.252-.189 0-.186.112-.402.252-.481.138-.081.252.004.252.191zM92.058 120.37c0 4.3-2.615 9.296-5.84 11.158-3.225 1.861-5.84-.115-5.84-4.416 0-4.3 2.615-9.295 5.84-11.157 3.225-1.863 5.84.114 5.84 4.415z",
  clipRule: "evenodd"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M86.82 134.297l-4.23-2.38 7.549-16.208 4.044 2.262-7.362 16.326z",
  clipRule: "evenodd"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M96.446 122.813c0 4.302-2.615 9.296-5.84 11.159-3.225 1.862-5.84-.115-5.84-4.415s2.615-9.296 5.84-11.159c3.225-1.861 5.84.115 5.84 4.415z",
  clipRule: "evenodd"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#20211F",
  fillRule: "evenodd",
  d: "M63.58 140.273l-4.48-2.707-3.017-2.416s2.4-.885 2.627-1.026c.225-.143 6.03 1.929 4.87 6.149z",
  clipRule: "evenodd"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M51.162 133.789l20.821-11.907 11.685 6.745-20.917 11.983-11.589-6.821z",
  clipRule: "evenodd"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M83.668 128.627l-21.02 12.023v5.701l21.02-12.014v-5.71z",
  clipRule: "evenodd"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M74.133 82.102l87.353-50.404L130.84 14 43.487 64.404l30.646 17.698z",
  clipRule: "evenodd"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M48.073 65.3l84.228-48.545-1.735-.894-84.227 48.543 1.734.897zM74.297 80.36l84.228-48.543-1.735-.897-84.227 48.545 1.734.895z",
  clipRule: "evenodd"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M43.487 64.404v48.176l30.646 17.683V82.102L43.487 64.404z",
  clipRule: "evenodd"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M124.002 61.08L100.326 74.74l-3.561 4.662 27.237-15.712V61.08zM124.002 56.475l-17.956 10.553-3.558 4.662 21.514-12.601v-2.614z",
  clipRule: "evenodd"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M74.133 82.008v48.255l87.353-50.39V31.604L74.133 82.008z",
  clipRule: "evenodd"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M79.16 81.972l-1.132.654v42.16l1.133-.654v-42.16zM84.234 79.047l-1.132.656v42.158l1.132-.654v-42.16zM101.596 68.996l-1.134.653v42.159l1.134-.653v-42.16zM106.668 66.071l-1.131.654v42.158l1.131-.652v-42.16zM112.078 63.033l-1.134.654v42.158l1.134-.653v-42.16zM117.15 60.108l-1.131.654v42.16l1.131-.654v-42.16zM122.66 56.717l-1.134.654v42.16l1.134-.655v-42.16zM127.732 53.792l-1.134.654v42.16l1.134-.654v-42.16zM148.502 41.718l-1.134.655v42.16l1.134-.655v-42.16zM153.574 38.794l-1.134.654v42.16l1.134-.655v-42.16z",
  clipRule: "evenodd"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M74.133 82.102l87.353-50.404L130.84 14 43.487 64.404l30.646 17.698z",
  clipRule: "evenodd"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M48.073 65.3l84.228-48.545-1.735-.894-84.227 48.543 1.734.897zM74.297 80.36l84.228-48.543-1.735-.897-84.227 48.545 1.734.895zM43.487 64.404v48.176l30.646 17.683V82.102L43.487 64.404z",
  clipRule: "evenodd"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M124.002 61.08L100.326 74.74l-3.561 4.662 27.237-15.712V61.08zM124.002 56.475l-17.956 10.553-3.558 4.662 21.514-12.601v-2.614z",
  clipRule: "evenodd"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M74.133 82.008v48.255l87.353-50.39V31.604L74.133 82.008z",
  clipRule: "evenodd"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M79.16 81.972l-1.132.654v42.16l1.133-.654v-42.16zM84.234 79.047l-1.132.656v42.158l1.132-.654v-42.16zM101.596 68.996l-1.134.653v42.159l1.134-.653v-42.16zM106.668 66.071l-1.131.654v42.158l1.131-.652v-42.16zM112.078 63.033l-1.134.654v42.158l1.134-.653v-42.16zM117.15 60.108l-1.131.654v42.16l1.131-.654v-42.16zM122.66 56.717l-1.134.654v42.16l1.134-.655v-42.16zM127.732 53.792l-1.134.654v42.16l1.134-.654v-42.16zM148.502 41.718l-1.134.655v42.16l1.134-.655v-42.16zM153.574 38.794l-1.134.654v42.16l1.134-.655v-42.16z",
  clipRule: "evenodd"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M58.85 139.811c0 4.3-2.616 9.296-5.842 11.159-3.226 1.862-5.84-.116-5.84-4.415 0-4.3 2.614-9.298 5.84-11.159 3.226-1.862 5.841.115 5.841 4.415z",
  clipRule: "evenodd"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M53.61 153.738l-4.228-2.379 7.546-16.209 4.046 2.262-7.364 16.326z",
  clipRule: "evenodd"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M63.237 142.256c0 4.302-2.615 9.296-5.84 11.157-3.225 1.863-5.84-.113-5.84-4.415 0-4.298 2.615-9.294 5.84-11.157 3.225-1.862 5.84.115 5.84 4.415z",
  clipRule: "evenodd"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "#E15A77",
  fillRule: "evenodd",
  d: "M56.557 110.945l-17.678-8.296V82.005L16.937 94.673l37.016 21.373 2.604-5.101z",
  clipRule: "evenodd"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M10.274 107.338L8.97 121.147l.175 15.248 8.883-5.129 21.69 12.68 11.325-22.198-38.333-22.131c-1.362 2.624-2.292 5.666-2.438 7.721zM16.937 94.673l-.157.091c-1.524.8-2.944 2.685-4.069 4.853l38.333 22.131 2.909-5.702-37.016-21.373z",
  clipRule: "evenodd"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M69.346 99.721L47.248 112.48c-3.372 1.767-6.242 8.821-6.507 12.573l-1.128 13.784v15.274l9.195-5.308c.755-5.219 3.936-10.649 7.75-12.851 3.81-2.199 6.992-.444 7.747 3.904l5.041-2.912V99.721z",
  clipRule: "evenodd"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M56.557 136.739c-3.456 1.995-6.34 6.913-7.025 11.644l-.724.42c.755-5.219 3.936-10.649 7.75-12.851 3.81-2.199 6.992-.444 7.747 3.904l-.725.417c-.686-3.94-3.569-5.529-7.023-3.534z",
  clipRule: "evenodd"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M8.971 121.147l30.642 17.69v15.274L8.971 136.42v-15.273z",
  clipRule: "evenodd"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M45.488 149.603l-5.845 3.383L8.97 135.27l.002-.859L7 135.51l32.641 18.89 4.037-2.331c.608-.35 1.289-.792 1.58-1.432l.23-1.034z",
  clipRule: "evenodd"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "#DE4B6A",
  fillRule: "evenodd",
  d: "M47.372 112.48l21.974-12.69L38.7 82.093 16.725 94.782l30.647 17.698z",
  clipRule: "evenodd"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M39.13 77.818c-.992.45-2.543 1.16-3.787 1.763-4.348 2.108-11.64 5.854-14.11 8.397-3.109 3.204-4.384 6.391-4.55 6.825l30.608 17.732s1.225-3.434 4.57-6.879c2.469-2.547 10.004-6.05 14.352-8.156 1.998-.969 3.133-1.833 3.133-1.833L39.13 77.818z",
  clipRule: "evenodd"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  fill: "#E05275",
  fillRule: "evenodd",
  d: "M51.19 109.019l-1.455-.835c.585-.806 1.29-1.667 2.126-2.528.615-.635 1.545-1.329 2.663-2.046l1.329.753-4.663 4.656z",
  clipRule: "evenodd"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M49.735 108.184L19.057 90.577c.252-.346.496-.668.733-.964.43-.535.91-1.085 1.443-1.635.564-.58 1.382-1.226 2.358-1.9l30.933 17.532c-1.118.717-2.048 1.411-2.663 2.046-.836.861-1.54 1.722-2.126 2.528z",
  clipRule: "evenodd"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M65.006 97.73c-4.35 2.106-10.676 5.379-13.145 7.926-3.345 3.445-4.57 6.879-4.57 6.879l22.055-12.209v-4.66c-1.003.49-3.117 1.497-4.34 2.063z",
  clipRule: "evenodd"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M44.23 122.484c0-.997.613-2.17 1.363-2.602l5.824-3.363c.222-.128.427-.169.614-.149-.194-.575-.689-.782-1.271-.447l-5.825 3.363c-.75.434-1.361 1.604-1.361 2.603l-.681 10.734c0 .705.306 1.134.748 1.18-.057-.166-.091-.359-.091-.582l.68-10.737z",
  clipRule: "evenodd"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M44.255 133.654l6.505-3.832c.75-.432 1.363-1.603 1.363-2.603v-10.264c0-.227-.035-.419-.092-.585-.186-.02-.392.021-.614.149l-5.824 3.363c-.75.432-1.362 1.605-1.362 2.602l-.681 10.737c0 .223.034.416.09.582.187.02.393-.022.615-.149zM39.613 140.906l-30.642-17.69v-2.069l30.642 17.69v2.069z",
  clipRule: "evenodd"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M34.692 137.822l-8.796-5.076-12.051-6.959s.09.556.219 1.374l20.408 11.781.22-1.12zM14.246 128.299l.35 2.226 19.346 11.169.35-1.82-20.046-11.575zM15.007 133.201l.032.164 18.46 10.658.03-.128c.057-.313.14-.761.236-1.269l-18.992-10.964c.096.619.18 1.161.234 1.539zM17.788 137.25c1.172.797 4.47 2.658 6.481 3.778 2.01 1.201 5.309 3.149 6.482 3.705 1.233.585 1.977.666 2.403.126l-17.771-10.261c.426 1.034 1.171 1.81 2.405 2.652z",
  clipRule: "evenodd"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M14.773 131.662l18.992 10.964c.055-.294.114-.608.177-.932l-19.346-11.169.177 1.137zM34.473 138.942l-20.409-11.781.182 1.138 20.046 11.575c.066-.336.127-.651.18-.932zM15.383 134.598l17.771 10.261c.153-.195.267-.471.344-.836l-18.46-10.658c.078.455.191.86.345 1.233z",
  clipRule: "evenodd"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M22.64 132.404c0 1.036.63 2.241 1.409 2.688.777.45 1.406-.027 1.406-1.064 0-1.035-.628-2.239-1.406-2.688-.778-.449-1.408.027-1.408 1.064z",
  clipRule: "evenodd"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M10.45 116.174c0 1 .612 2.169 1.361 2.603l25.362 14.281c.75.433 1.361-.031 1.361-1.029l.968-8.53-28.048-16.194-1.005 8.869z",
  clipRule: "evenodd"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M38.406 118.544l-25.363-14.281c-.749-.432-1.361.03-1.361 1.029l-.228 2.013L39.5 123.499l.267-2.352c0-.999-.612-2.171-1.362-2.603z",
  clipRule: "evenodd"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M61.393 143.138c0 2.788-1.696 6.027-3.786 7.232-2.09 1.209-3.786-.074-3.786-2.862 0-2.788 1.695-6.026 3.786-7.232 2.09-1.209 3.786.074 3.786 2.862z",
  clipRule: "evenodd"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M60.323 143.755c0 2.001-1.216 4.324-2.716 5.189-1.5.868-2.716-.052-2.716-2.053 0-1.999 1.215-4.324 2.716-5.19 1.5-.865 2.716.054 2.716 2.054z",
  clipRule: "evenodd"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M58.92 144.565c0 .967-.589 2.091-1.313 2.509-.726.419-1.314-.025-1.314-.993 0-.966.588-2.089 1.314-2.508.724-.419 1.313.025 1.313.992zM57.859 142.469c0 .185-.114.399-.252.48-.14.08-.252-.005-.252-.191 0-.185.112-.401.252-.48.138-.08.252.005.252.191zM59.562 142.469c0 .185-.113.399-.252.48-.139.08-.252-.005-.252-.191 0-.185.113-.401.252-.48.139-.08.252.005.252.191zM56.293 144.352c0 .185-.112.401-.252.48-.139.08-.252-.003-.252-.189 0-.185.113-.401.252-.482.14-.079.252.005.252.191zM59.562 146.005c0 .184-.113.399-.252.481-.139.08-.252-.006-.252-.191 0-.186.113-.402.252-.481.139-.081.252.004.252.191zM56.293 147.888c0 .185-.112.401-.252.483-.139.079-.252-.006-.252-.191 0-.186.113-.402.252-.483.14-.079.252.005.252.191zM59.968 144.097c0 .187-.113.403-.251.483-.14.079-.252-.006-.252-.191 0-.184.112-.4.252-.482.138-.079.252.006.252.19zM55.789 146.505c0 .186-.112.401-.252.481-.137.081-.252-.004-.252-.19 0-.185.115-.401.252-.48.14-.082.252.004.252.189zM57.859 147.888c0 .185-.114.401-.252.483-.14.079-.252-.006-.252-.191 0-.186.112-.402.252-.483.138-.079.252.005.252.191z",
  clipRule: "evenodd"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M61.393 143.138c0 2.788-1.696 6.027-3.786 7.232-2.09 1.209-3.786-.074-3.786-2.862 0-2.788 1.695-6.026 3.786-7.232 2.09-1.209 3.786.074 3.786 2.862z",
  clipRule: "evenodd"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M60.323 143.755c0 2.001-1.216 4.324-2.716 5.189-1.5.868-2.716-.052-2.716-2.053 0-1.999 1.215-4.324 2.716-5.19 1.5-.865 2.716.054 2.716 2.054z",
  clipRule: "evenodd"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M58.92 144.565c0 .967-.589 2.091-1.313 2.509-.726.419-1.314-.025-1.314-.993 0-.966.588-2.089 1.314-2.508.724-.419 1.313.025 1.313.992zM57.859 142.469c0 .185-.114.399-.252.48-.14.08-.252-.005-.252-.191 0-.185.112-.401.252-.48.138-.08.252.005.252.191zM59.562 142.469c0 .185-.113.399-.252.48-.139.08-.252-.005-.252-.191 0-.185.113-.401.252-.48.139-.08.252.005.252.191zM56.293 144.352c0 .185-.112.401-.252.48-.139.08-.252-.003-.252-.189 0-.185.113-.401.252-.482.14-.079.252.005.252.191zM59.562 146.005c0 .184-.113.399-.252.481-.139.08-.252-.006-.252-.191 0-.186.113-.402.252-.481.139-.081.252.004.252.191zM56.293 147.888c0 .185-.112.401-.252.483-.139.079-.252-.006-.252-.191 0-.186.113-.402.252-.483.14-.079.252.005.252.191zM59.968 144.097c0 .187-.113.403-.251.483-.14.079-.252-.006-.252-.191 0-.184.112-.4.252-.482.138-.079.252.006.252.19zM55.789 146.505c0 .186-.112.401-.252.481-.137.081-.252-.004-.252-.19 0-.185.115-.401.252-.48.14-.082.252.004.252.189zM57.859 147.888c0 .185-.114.401-.252.483-.14.079-.252-.006-.252-.191 0-.186.112-.402.252-.483.138-.079.252.005.252.191z",
  clipRule: "evenodd"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M94.393 124.138c0 2.788-1.696 6.027-3.786 7.232-2.09 1.209-3.786-.074-3.786-2.862 0-2.788 1.695-6.026 3.786-7.232 2.09-1.209 3.786.074 3.786 2.862z",
  clipRule: "evenodd"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  fillRule: "evenodd",
  d: "M93.323 124.755c0 2.001-1.216 4.324-2.716 5.189-1.5.868-2.716-.052-2.716-2.053 0-1.999 1.215-4.324 2.716-5.19 1.5-.865 2.716.054 2.716 2.054z",
  clipRule: "evenodd"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M91.92 125.565c0 .967-.589 2.091-1.313 2.509-.726.419-1.314-.025-1.314-.993 0-.966.588-2.089 1.314-2.508.724-.419 1.313.025 1.313.992zM90.859 123.469c0 .185-.113.399-.252.48-.14.08-.252-.005-.252-.191 0-.185.112-.401.252-.48.139-.08.252.005.252.191zM92.562 123.469c0 .185-.114.399-.252.48-.139.08-.252-.005-.252-.191 0-.185.113-.401.252-.48.138-.08.252.005.252.191zM89.293 125.352c0 .185-.112.401-.252.48-.139.08-.252-.003-.252-.189 0-.185.113-.401.252-.482.14-.079.252.005.252.191zM92.562 127.005c0 .184-.114.399-.252.481-.139.08-.252-.006-.252-.191 0-.186.113-.402.252-.481.138-.081.252.004.252.191zM89.293 128.888c0 .185-.112.401-.252.483-.139.079-.252-.006-.252-.191 0-.186.113-.402.252-.483.14-.079.252.005.252.191zM92.969 125.097c0 .187-.114.403-.252.483-.14.079-.252-.006-.252-.191 0-.184.112-.4.252-.482.138-.079.252.006.252.19zM88.79 127.505c0 .186-.113.401-.253.481-.137.081-.252-.004-.252-.19 0-.185.115-.401.252-.48.14-.082.252.004.252.189zM90.859 128.888c0 .185-.113.401-.252.483-.14.079-.252-.006-.252-.191 0-.186.112-.402.252-.483.139-.079.252.005.252.191z",
  clipRule: "evenodd"
});

function SvgSpaceVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 162,
    fill: "none",
    viewBox: "0 0 170 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceVehicle);
export default __webpack_public_path__ + "static/media/spaceVehicle.84cee376.svg";
export { ForwardRef as ReactComponent };